import { useSelector } from "react-redux"

import { Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

import { DropdownFilterContainer, StyledMenuItem, StyledSelect } from "./Atom"

const DropdownFilter = (props: any) => {
  const {
    id,
    disabled,
    handleFilter,
    retainedValue,
    filterData,
    headerLabel,
    selectedGroupFilter,
  } = props

  return (
    <DropdownFilterContainer>
      <Typography fontSize={10}>{headerLabel}</Typography>
      <StyledSelect
        disabled={disabled}
        displayEmpty
        onChange={handleFilter}
        renderValue={(): any =>
          id == 1
            ? selectedGroupFilter
              ? retainedValue?.label
              : `Select Group`
            : retainedValue?.label
        }
        IconComponent={ExpandMoreIcon}
      >
        {filterData?.map((item: any) => (
          <StyledMenuItem value={item}>{item?.label}</StyledMenuItem>
        ))}
      </StyledSelect>
    </DropdownFilterContainer>
  )
}

export default DropdownFilter
